import { inject } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  createUrlTreeFromSnapshot,
} from '@angular/router'
import { AuthenticationService } from './authentication.service'
import { FeatureAccessService } from './feature-access.service'

export const mergeLogsGuard = async (next: ActivatedRouteSnapshot) => {
  const authService = inject(AuthenticationService)
  const featureAccessService = inject(FeatureAccessService)

  const isAuthenticated = await authService.isAuthenticated()
  if (!isAuthenticated) {
    return createUrlTreeFromSnapshot(next, ['/', 'login'])
  }

  const hasFeatureAccess = await featureAccessService.canAccessMergeLogs()
  if (!hasFeatureAccess) {
    return createUrlTreeFromSnapshot(next, ['/', 'customers'])
  }

  return true
}
